module.exports = __webpack_public_path__ + "img/v2.3.b5b433d3.png";